import {AfterViewInit, Component, HostBinding, Input, OnInit, TemplateRef, ViewChild, inject} from '@angular/core';
import { FilteringLogic, IgxStringFilteringOperand } from '@infragistics/igniteui-angular/core';
import {
  IGridEditDoneEventArgs, IGridEditEventArgs, IgxColumnComponent, IgxExcelExporterService, IgxPdfExporterService,
  IgxGridCell, IgxGridStateDirective, RowType
} from '@infragistics/igniteui-angular/grids/core';
import { IGX_GRID_DIRECTIVES, IgxGridComponent, IgxGridModule } from '@infragistics/igniteui-angular/grids/grid';
import { IgxIconComponent } from '@infragistics/igniteui-angular/icon';
import { IgxButtonDirective, IgxButtonModule, IgxFocusDirective, IgxRippleDirective, IgxRippleModule, IgxTextSelectionDirective } from '@infragistics/igniteui-angular/directives';
import {IGX_INPUT_GROUP_DIRECTIVES, IgxInputGroupComponent} from '@infragistics/igniteui-angular/input-group';
import { IGX_ACTION_STRIP_DIRECTIVES, IgxActionStripModule } from '@infragistics/igniteui-angular/action-strip';
import {ClsConfig} from '../../../util/cls-config';
import {ClsUtil} from '../../../util/cls-util';
import {MasOpcionesGridComponent} from '../../util/controles/mas-opciones-grid/mas-opciones-grid.component';
import {AppPresupuestosService} from '../../../core/services/app-presupuestos.service';
import {AppInfoService} from '../../../core/services/app-info.service';
import {GenericoService} from '../../../core/services/generico.service';
import {ClsObjCrudCatalogos} from '../../../clases-pu/02-catalogos/cls-obj-crud-catalogos';
import {EnumMasOpciones} from '../../../core/models/enum/enum-mas-opciones';
import {INeodataGridCell, INeodataMenu} from '../../../core/models/interfaces/generico-interface';
import {EnumMCGenerales} from '../../../core/models/enum/enum-menu-contextual';
import {EnumNombresGrids} from '../../../core/models/enum/enum-nombres-grids';
import {ClsObjConfiguracionGrid} from '../../../clases-pu/util/cls-obj-configuracion-grid';
import {ClsObjGenerico} from '../../../clases-pu/util/cls-obj-generico';
import {EnumTresPuntos} from '../../../core/models/enum/enum-tres-puntos';
import {ClsObjCopiado} from '../../../clases-pu/01-presupuesto/copiado/cls-obj-copiado';
import {DetallePegadoComponent} from '../../util/ventanas/detalle-pegado/detalle-pegado.component';
import {VtnGenericaComponent} from '../../util/ventanas/vtn-generica/vtn-generica.component';
import {FiltroGeneralModernoComponent} from '../../util/controles/filtro-general-moderno/filtro-general-moderno.component';
import {ClsObjPegado} from 'src/app/clases-pu/99-herramientas/pegado/cls-obj-pegado';
import {TranslateModule} from '@ngx-translate/core';
import {ContextMenuGenericoComponent} from '../../util/controles/context-menu-generico/context-menu-generico.component';
import {UppercaseDirective} from '../../../core/directivas/uppercase.directive';
import {FormsModule} from '@angular/forms';
import {PasteHandlerNeodataDirective} from '../../../core/directivas/paste-handler-neodata.directive';
import {ClsResponsables} from 'src/app/core/models/cls-catalogos';
import {ClsColDetallePegado} from "../../../core/models/cls-pegado";
import {TipoMensajesService} from "../../../core/services/tipo-mensajes.service";
import {SummaryPipeNeoPipe} from "../../../core/pipes/summary-pipe-neo.pipe";
import {CrearComponenteDinamicoService} from "../../../core/services/crear-componente-dinamico.service";

@Component({
  selector: 'app-responsables',
  templateUrl: './responsables.component.html',
  styleUrls: ['./responsables.component.scss'],
  imports: [
    IgxGridModule,
    IGX_GRID_DIRECTIVES,
    TranslateModule,
    FiltroGeneralModernoComponent,
    IgxIconComponent,
    MasOpcionesGridComponent,
    PasteHandlerNeodataDirective,
    IGX_INPUT_GROUP_DIRECTIVES,
    IgxButtonModule,
    IgxButtonDirective,
    IgxActionStripModule,
    IGX_ACTION_STRIP_DIRECTIVES,
    FormsModule,
    UppercaseDirective,
    IgxTextSelectionDirective,
    IgxFocusDirective,
    ContextMenuGenericoComponent,
    IgxRippleModule,
    IgxRippleDirective,
    SummaryPipeNeoPipe,
    IgxInputGroupComponent
  ],
  providers: [SummaryPipeNeoPipe]
})
export class ResponsablesComponent extends ClsConfig implements OnInit, AfterViewInit {
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);
  private servicioGen = inject(GenericoService);
  private tipoMsg = inject(TipoMensajesService);
  private summaryPipe = inject(SummaryPipeNeoPipe);
  private excelExportService = inject(IgxExcelExporterService);
  private pdfExportService = inject(IgxPdfExporterService);
  private crearCompDinamico = inject(CrearComponenteDinamicoService);

  @ViewChild('gridResponsables', {read: IgxGridComponent, static: true})
  public gridResponsables: IgxGridComponent;
  @ViewChild('masOpcionesG', {read: MasOpcionesGridComponent, static: true})
  public masOpcionesG: MasOpcionesGridComponent;
  @ViewChild('filtroGeneral', {read: FiltroGeneralModernoComponent, static: true})
  public filtroGeneral: FiltroGeneralModernoComponent;
  @Input()
  public modoEdicion = true;
  // ajuste de texto
  @HostBinding('class') public themesClass = 'noAjustarTexto';
  public clicked = false;

  public errorAlCargar: boolean;
  public dataResponsables: ClsResponsables[] = [];
  public activarBotones = false;
  // mostrar actionStrip
  public showActionStrip = true;
  // clase catalogos
  public mObjCRUDCatalogos: ClsObjCrudCatalogos = new ClsObjCrudCatalogos();
  private mObjGenerico: ClsObjGenerico = new ClsObjGenerico();
  private mObjCopiado: ClsObjCopiado = new ClsObjCopiado();
  private mObjPegado: ClsObjPegado = new ClsObjPegado();
  // menucontextual
  public verContextMenu = false;
  public contextmenuX = 0;
  public contextmenuY = 0;
  public cellMenuContextaul: IgxGridCell;
  public menus: INeodataMenu[] = [];
  public lengthMenu: number;
  public subMenusOpciones: any[];
  public sizeMenu = '';
  // CONFIGGRIDS: definir cada ng-Template que tengamos en el HTML
  @ViewChild('responsableHeaderTemplate', {static: true}) public responsableHeaderTemplate: TemplateRef<any>;
  @ViewChild('responsableEditorTemplate', {static: true}) public responsableEditorTemplate: TemplateRef<any>;
  @ViewChild('nombreResponsableHeaderTemplate', {static: true}) public nombreResponsableHeaderTemplate: TemplateRef<any>;
  @ViewChild('nombreResponsableEditorTemplate', {static: true}) public nombreResponsableEditorTemplate: TemplateRef<any>;
  @ViewChild('cargoResponsableEditorTemplate', {static: true}) public cargoResponsableEditorTemplate: TemplateRef<any>;
  @ViewChild('telefonoResponsableEditorTemplate', {static: true}) public telefonoResponsableEditorTemplate: TemplateRef<any>;
  @ViewChild('mailResponsableEditorTemplate', {static: true}) public mailResponsableEditorTemplate: TemplateRef<any>;
  @ViewChild(IgxGridStateDirective, {static: true}) public state;
  // Grid Layout
  public mObjConfigGrids: ClsObjConfiguracionGrid = new ClsObjConfiguracionGrid();
  // ConfigGridLayout
  public optionsGridLocal = {
    cellSelection: true,
    rowSelection: false,
    filtering: false,
    advancedFiltering: true,
    paging: true,
    sorting: false,
    groupBy: true,
    columns: true,
    expansion: true,
    rowPinning: false,
    columnSelection: true
  };
  public vtnGenerico: VtnGenericaComponent;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.gridResponsables.data = [];
  }

  public ngAfterViewInit() {
    // se genera la plantilla default del grid
    const stateDefault = this.state.getState(true);

    this.mObjConfigGrids.saveGridState(EnumNombresGrids.Responsables, true, stateDefault, '', this.clicked);
    const state = this.mObjConfigGrids.initGridState(EnumNombresGrids.Responsables);
    if (!ClsUtil.esNulo(state[0])) {
      this.state.setState(state[0]);
    }
    this.clicked = state[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public onColumnInit(column: IgxColumnComponent) {
    switch (column.field) {
      case 'Responsable':
        column.headerTemplate = this.responsableHeaderTemplate;
        column.inlineEditorTemplate = this.responsableEditorTemplate;
        break;
      case 'NombreResponsable':
        column.headerTemplate = this.nombreResponsableHeaderTemplate;
        column.inlineEditorTemplate = this.nombreResponsableEditorTemplate;
        column.summaries = this.summaryPipe.transform('filasSummary');
        break;
      case 'CargoResponsable':
        column.inlineEditorTemplate = this.cargoResponsableEditorTemplate;
        break;
      case 'TelefonoResponsable':
        column.inlineEditorTemplate = this.telefonoResponsableEditorTemplate;
        break;
      case 'MailResponsable':
        column.inlineEditorTemplate = this.mailResponsableEditorTemplate;
        break;
    }
    // column.cellClasses = this.backgroundClasses;
  }

  public async cargarResponsables() {
    if (!ClsUtil.esNulo(this.infPpto.organizacion)) {
      try {
        this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.GET_CATALOGOS');
        this.mObjCRUDCatalogos.dataCatalogo = [];
        this.dataResponsables = [];
        await this.mObjCRUDCatalogos.obtenerCatalogo(0, 'ConsultarResponsables2021');
        this.mObjCRUDCatalogos.dataCatalogo.forEach(item => {
          const resp: ClsResponsables = {
            IdResponsable: item.IdResponsable,
            Responsable: item.Responsable,
            NombreResponsable: item.NombreResponsable,
            CargoResponsable: item.CargoResponsable,
            TelefonoResponsable: item.TelefonoResponsable,
            MailResponsable: item.MailResponsable
          };
          this.dataResponsables.push(resp);
        });
        this.gridResponsables.data = this.dataResponsables;
        this.errorAlCargar = false;
        this.tipoMsg.cerrarWaitDialog();
      } catch (e) {
        this.tipoMsg.cerrarWaitDialog();
        this.errorAlCargar = true;
        this.tipoMsg.mostrarMsg(e.message, 'error');
      }
    }
  }

  public menuContextual(evt: any) {
    evt.event.preventDefault();
    this.disableContextMenu();
    this.disableAllContextMenu();
    this.menus = this.mObjCRUDCatalogos.crearMenuContextual({
      esCliente: false,
      esUnidad: false,
      esEmpresa: false
    }, this.infPpto.esPptoMaestro);
    this.subMenusOpciones = [];
    this.lengthMenu = this.menus.filter(x => !x.disabled).length;
    this.contextmenuX = ClsUtil.calcPosition(document.body.clientWidth, evt.event.clientX, true, this.lengthMenu);
    this.contextmenuY = ClsUtil.calcPosition(document.body.clientHeight, evt.event.clientY, false, this.lengthMenu);
    this.sizeMenu = (this.lengthMenu * 37) + 'px';
    this.cellMenuContextaul = evt.cell;
    this.verContextMenu = true;
  }

  public disableContextMenu() {
    if (this.verContextMenu) {
      this.verContextMenu = false;
    }
  }

  public disableAllContextMenu() {
    this.mObjGenerico.disableAllContextMenu(this.infPpto);
  }

  public clearInput() {
    this.filtroGeneral.input.value = '';
    this.gridResponsables.clearFilter();
  }

  public async accionSeleccionada(evt: INeodataGridCell) {
    try {
      switch (evt.accionMenu.id) {
        case EnumMCGenerales.Copiar:
          await this.copiarData();
          break;
        case EnumMCGenerales.Pegar:
          let data: any = await navigator.clipboard.readText().then((data2) => data2);
          data = this.pasteHandlerNeo.processData(data);
          await this.datosPegadosDesdeExcel(data);
          break;
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMCGenerales.GuardarLayout:
          const state = this.state.getState(true);
          this.mObjConfigGrids.saveGridState(EnumNombresGrids.Responsables, false, '', state, !this.clicked);
          break;
        case EnumMCGenerales.ReestablecerLayout:
          this.restoreGrid();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public restoreGrid() {
    const stateDefault = this.mObjConfigGrids.restoreGrid(EnumNombresGrids.Responsables);
    if (!ClsUtil.esNulo(stateDefault[0])) {
      this.state.setState(stateDefault[0]);
    }
    this.clicked = stateDefault[1];
    const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
    this.themesClass = result.themesClass;
    this.clicked = result.clicked;
  }

  public filterInput(filtro: string) {
    this.gridResponsables.filteringLogic = FilteringLogic.Or;
    this.gridResponsables.filterGlobal(filtro, IgxStringFilteringOperand.instance().condition('contains'));
  }

  public rowEditEnter() {
    this.showActionStrip = false;
  }

  public rowEditExit() {
    this.showActionStrip = true;
  }

  // evento que se ocupa para guardar o modificar
  public async addUpdateResponsable(responsable: IGridEditDoneEventArgs) {
    const newValor: ClsResponsables = responsable.newValue;
    const oldValor: ClsResponsables = responsable.oldValue;
    if (responsable.isAddRow) {
      await this.agregarModificarResponsable(newValor, oldValor, responsable.isAddRow);
    } else {
      // al editar los campos, validar que sean distintos para ocupar el servicio
      if (this.mObjCRUDCatalogos.validarSiCambioCamposCatalogos(newValor, oldValor, EnumTresPuntos.Responsables)) {
        await this.agregarModificarResponsable(newValor, oldValor, responsable.isAddRow);
      }
    }
  }

  private async agregarModificarResponsable(newResponsable: ClsResponsables, oldResponsable: ClsResponsables, isAddRow: boolean) {
    let respuesta: bigint;
    const objCatalogo: ClsResponsables = new ClsResponsables();
    try {
      objCatalogo.IdResponsable = isAddRow ? ClsUtil.parseJSONBig(0) : newResponsable.IdResponsable;
      objCatalogo.Responsable = newResponsable.Responsable.toUpperCase();
      objCatalogo.NombreResponsable = newResponsable.NombreResponsable;
      objCatalogo.CargoResponsable = newResponsable.CargoResponsable;
      objCatalogo.TelefonoResponsable = newResponsable.TelefonoResponsable;
      objCatalogo.MailResponsable = newResponsable.MailResponsable;
      this.tipoMsg.mostrarWaitDialog(isAddRow ? 'MENSAJES.WAIT.GUARDANDO_CATALOGO' : 'MENSAJES.WAIT.MODIFICANDO_CATALOGO');
      respuesta = await this.mObjCRUDCatalogos.agregarModificarCatalogo([objCatalogo], 'ResponsablesRegistraActualiza2021');
      if (isAddRow) {
        newResponsable.IdResponsable = respuesta;
      }
      this.tipoMsg.mostrarToast(isAddRow ? 'MENSAJES.TOAS.GUARDANDO_CATALOGO' : 'MENSAJES.TOAS.MODIFICANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.cancelarAddUpdateResponsables(newResponsable, oldResponsable, isAddRow);
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa cuando manda error al intentar agregar o modificar,
  // al agregar si manda error se quita la fila del grid
  // al editar si manda error se regresa a los valores anteriores
  private cancelarAddUpdateResponsables(newResponsable: ClsResponsables, oldResponsable: ClsResponsables, isAddRow: boolean) {
    if (isAddRow) {
      this.gridResponsables.deleteRowById(newResponsable.IdResponsable);
    } else {
      this.gridResponsables.updateRow(oldResponsable, oldResponsable.IdResponsable);
    }
  }

  private async eliminarResponsable(rowContext: RowType) {
    const responsable: ClsResponsables = rowContext.data;
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.ELIMINANDO_CATALOGO', undefined, 'delete');
      await this.mObjCRUDCatalogos.eliminarCatalogo(responsable.IdResponsable, 'EliminarResponsables2021');
      this.gridResponsables.getRowByIndex(rowContext.index).delete();
      this.tipoMsg.mostrarToast('MENSAJES.TOAS.ELIMINANDO_CATALOGO');
      this.tipoMsg.cerrarWaitDialog();
    } catch (e) {
      this.tipoMsg.cerrarWaitDialog();
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  // se ocupa el evento rowEdit para validar uno o varios campos obligatorios,
  // si falta algun campo de toda la fila se cancela la edicion y se manda mensaje de que campos faltan
  // en caso de ser todo OK, procede al agregado o modificado
  public validarResponsable(responsable: IGridEditEventArgs) {
    const valor: ClsResponsables = responsable.newValue;
    responsable.cancel = this.esValido(valor, responsable, responsable.isAddRow);
  }

  // en este caso se pasa el valor de la unidad, ya que es el unico campo obligatorio,
  // en caso de ser mas campos a validar, pasar toda la clase
  private esValido(responsables: ClsResponsables, resp: any, isAddRow: boolean): boolean {
    // validar campos obligatorios
    if (ClsUtil.esNulo(responsables.Responsable)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.RESPONSABLE.COL_RESPONSABLE')));
      return true;
    }

    if (ClsUtil.esNulo(responsables.NombreResponsable)) {
      this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertValidarCampos(this.mObjGenerico.getTranslationValidarColuma('GRIDS.RESPONSABLE.COL_NOMBRE')));
      return true;
    }
    // valida si ya existe la empresa cuando se agrega o modifica
    if (isAddRow) {
      if (this.dataResponsables.findIndex(responsable => responsable.Responsable === responsables.Responsable) !== -1) {
        this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(responsables.Responsable));
        return true;
      }
    } else {
      if (responsables.Responsable !== resp.oldValue.Responsable) {
        if (this.dataResponsables.findIndex(responsable => responsable.Responsable === responsables.Responsable) !== -1) {
          this.tipoMsg.mostrarMsg(this.mObjGenerico.getTranslationsAlertRegistroExistente(responsables.Responsable));
          return true;
        }
      }
    }
    return false;
  }

  public accionStripRowBtn(rowContext: RowType, indexBtn: number) {
    try {
      switch (indexBtn) {
        case 1:
          this.beginAddRowByIndexNeo(this.gridResponsables, rowContext.index);
          break;
        case 2:
          this.tipoMsg.mostrarQuestion((resp: boolean) => {
            if (resp) {
              this.eliminarResponsable(rowContext);
            }
          }, this.mObjGenerico.getTranslationsQuestionBorrar(rowContext.data.Responsable));
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public async onSelectionDropDown(opcion: string) {
    try {
      switch (opcion) {
        case EnumMasOpciones.Ajustar:
          const result: { themesClass: string, clicked: boolean } = ClsUtil.ajustarTexto(this.clicked);
          this.themesClass = result.themesClass;
          this.clicked = result.clicked;
          break;
        case EnumMasOpciones.ExportarExcel:
          const sms = await ClsUtil.exportarDatos(this.gridResponsables, this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.RESPONSABLES'), this.excelExportService).then(sms => { return sms });
          this.tipoMsg.mostrarToast(this.mObjGenerico.getTranslationsSmsExportar(sms, this.gridResponsables.selectedRows.length));
          break;
        case EnumMasOpciones.ExportarPDF:
          await ClsUtil.abrirVentanaPersonalizarPDF(
            this.gridResponsables,
            this.mObjGenerico.getTranslationsGetCatalogos('MENSAJES.GRALS.RESPONSABLES'),
            this.pdfExportService,
            this.crearCompDinamico,
            this.tipoMsg,
            this.mObjGenerico
          );
          break;
        case EnumMasOpciones.Actualizar:
          await this.cargarResponsables();
          break;
        case EnumMasOpciones.LimpiarFiltroColumnas:
          this.clearInput();
          break;
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }

  public handleRowSelection() {
    this.gridResponsables.nativeElement.focus();
  }

  public async datosPegadosDesdeExcel(datosPegado: any[]) {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.PEGANDO');
      let arrayResponsables: ClsResponsables[] = [];
      let dataDetalle: ClsColDetallePegado[];
      const colRes: string = this.mObjGenerico.getTranslationsSubject('GRIDS.RESPONSABLE.COL_RESPONSABLE');
      const colNom: string = this.mObjGenerico.getTranslationsSubject('GRIDS.RESPONSABLE.COL_NOMBRE');
      const colCar: string = this.mObjGenerico.getTranslationsSubject('GRIDS.RESPONSABLE.COL_CARGO');
      const colTel: string = this.mObjGenerico.getTranslationsSubject('GRIDS.RESPONSABLE.COL_TELEFONO');
      const colMail = 'Mail';
      this.mObjCopiado.columnasRequeridas = [colRes, colNom];
      if (this.mObjCopiado.validarCamposRequeridos(datosPegado)) {
        let datos = this.mObjCopiado.procesarDatos(datosPegado, true);
        datos = this.mObjPegado.mergeDescriptions(datos, EnumNombresGrids.Responsables);
        dataDetalle = this.mObjPegado.verificarDetallePegado(datos, [colRes, colNom, colCar, colTel, colMail], [colRes, colNom], EnumNombresGrids.Responsables, this.mObjGenerico);
        if (dataDetalle.length > 0) {
          const vtnGenerico = this.crearCompDinamico.crearComponente(VtnGenericaComponent).instance as VtnGenericaComponent;
          vtnGenerico.queVtnEstaAbierta = 'PegadoEspecial';
          const vtnDiferencia = vtnGenerico.crearComponente(DetallePegadoComponent);
          vtnDiferencia.dataDetalle = dataDetalle;
          vtnDiferencia.open();
        } else {
          datos.forEach(x => {
            const valRes: string = (x[colRes] as string).toUpperCase();
            // validamos la cadena, si es undifine o null, le asignamos '' en caso contrario el valor
            // esto se hace porque la columna descripcion no es obligado, puede venir o no
            const valNom: string = ClsUtil.cadenaX(x[colNom] as string);
            const valCar: string = ClsUtil.cadenaX(x[colCar] as string);
            const valTel: string = ClsUtil.cadenaX(x[colTel] as string);
            const valMail: string = ClsUtil.cadenaX(x[colMail] as string);
            const resp: any = this.mObjCRUDCatalogos.crearObjCatalogos(this.dataResponsables, [valRes, valNom, valCar, valTel, valMail], [colRes, colNom, colCar, colTel, colMail], EnumTresPuntos.Responsables, this.mObjGenerico);
            if (!ClsUtil.esNulo(resp.esNuevo)) {
              if (resp.esNuevo) {
                arrayResponsables.push(resp.obj);
              } else {
                this.gridResponsables.updateCell(valRes, resp.obj.IdResponsable, 'Responsable');
                this.gridResponsables.updateCell(valNom, resp.obj.IdResponsable, 'NombreResponsable');
                this.gridResponsables.updateCell(valCar, resp.obj.IdResponsable, 'CargoResponsable');
                this.gridResponsables.updateCell(valTel, resp.obj.IdResponsable, 'TelefonoResponsable');
                this.gridResponsables.updateCell(valMail, resp.obj.IdResponsable, 'MailResponsable');
                arrayResponsables.push(resp.obj);
              }
            }
          });
          // invocar servicio para agregar o modificar siempre y cuando el arrayUnidades tenga valor
          if (arrayResponsables.length > 0) {
            const respuesta: any = await this.mObjCRUDCatalogos.agregarModificarCatalogo(arrayResponsables, 'ResponsablesRegistraActualiza2021', false);
            // filtro los registros con id 0
            arrayResponsables = arrayResponsables.filter(value => value.IdResponsable === BigInt(0));
            // iteramos la respuesta para ir asignando los ids para los registros nuevos
            const key: string[] = Object.keys(respuesta);
            key.forEach(x => {
              const res: ClsResponsables = arrayResponsables.find(value1 => value1.Responsable === x);
              if (!ClsUtil.esNulo(res)) {
                res.IdResponsable = ClsUtil.bigintX(respuesta[x]);
                this.gridResponsables.addRow(res);
              }
            });
          }
        }
      }
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public async customKeydown(eventArgs) {
    const ctrl = eventArgs.ctrlKey;
    const key = eventArgs.keyCode;
    // Ctrl-C ||  Cmd-C
    if ((ctrl || eventArgs.metaKey) && key === 67) {
      await this.copiarData();
    }
  }

  public async copiarData() {
    try {
      this.tipoMsg.mostrarWaitDialog('MENSAJES.WAIT.COPIANDO');
      const msg: string = await ClsUtil.copiarDatosGrids(this.gridResponsables, 'IdResponsable', this.mObjGenerico);
      msg && this.tipoMsg.mostrarToast(msg);
    } catch (e) {
      throw new Error(e.message);
    } finally {
      this.tipoMsg.cerrarWaitDialog();
    }
  }

  public clearProps() {
    this.gridResponsables.clearSort();
    this.gridResponsables.clearFilter();
    this.gridResponsables.clearSearch();
    this.gridResponsables.deselectAllRows();
    this.clearInput();
  }

  public registroSeleccionado() {
    const rowSeleccionados: bigint[] = this.gridResponsables.selectedRows;
    try {
      if (rowSeleccionados.length === 0) {
        throw new Error('MENSAJES.ALERT.SELECCIONAR_REGISTRO');
      }
      const rowData = this.gridResponsables.getRowData(rowSeleccionados[0]);
      this.gridResponsables.doubleClick.emit(rowData);
    } catch (e) {
      this.tipoMsg.mostrarMsg(e.message, 'error');
    }
  }
}
